module.exports = __webpack_public_path__ + "img/personal-center-upload-grey.38b0b286.svg";